import { SQLGeneratedProcess } from "@avenueops/shared-types";
import { DateFormat } from "@avenueops/web-components";
import { useUser } from "context/UserContext";
import { getClientTime } from "utils/time";

interface Props {
  row: SQLGeneratedProcess;
}

export default function CreatedAt({ row }: Props) {
  const user = useUser();
  return <DateFormat type="ABSOLUTE" date={row.created_at} timeZone={user.timeZone ?? undefined} />;
}
